// using jQuery
export function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    let cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = $.trim(cookies[i]);
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export function dialogBox(title, message, actions) {
  return new Promise((resolve, reject) => {
    let div = document.createElement('div');
    let buttons = '';
    console.log('actions', actions)
    for (let id in actions) {
      buttons += `<button id="dialogbox_action_${id}" type="button" class="btn btn-default">${actions[id]}</button>`

      div.innerHTML = `<div class="modal" tabindex="-1" role="dialog" id="dialogbox" data-backdrop="static">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">${title}</h4>
              </div>
              <div class="modal-body">
                <p>${message}</p>
              </div>
              <div class="modal-footer">
              ${ buttons }
              </div>
            </div>
          </div>
        </div>`;
      document.querySelector('body').appendChild(div);
      $(document).ready(function() {
        $('#dialogbox').modal('show');
        for (let id in actions) {
          $('#dialogbox_action_' + id).click(e => {
            $('#dialogbox').modal('hide');
            $('#dialogbox').parent().remove();
            $('.modal-backdrop').remove();
            resolve(id)
          });
        }
      });
    }
  });
}
